<template>
  <div :style="topBox">
    <div class="centerBox">
      <div class="topMenu">
        <div class="leftitem">
          <logo></logo>
          <!--定位-->
          <!-- <location></location> -->
        </div>
        <div class="rightitem">
          <top-menu-item></top-menu-item>
        </div>
      </div>
      <div class="searchBlock">
        <search></search>
      </div>
    </div>
  </div>
</template>

<script>
  import TopMenuItem from './TopMenuItem.vue'
  import search from './search.vue'
  import Logo from './Logo.vue'
  // import Location from './Location.vue'

export default {
    components: {
        'top-menu-item': TopMenuItem,
        'search' : search,
        'logo' : Logo,
        // 'location' : Location,
    },
    data(){
      let topboxConfig = this.$store.state.malMainPageConfig.topbox;
      return {
        topBox:{
            backgroundImage: "url("+topboxConfig.bgImgSrc+")",
            display: "flex",
            justifyContent: ["stretch","center"]
        }
      }
    },
    computed:{
      // topboxConfig :function(){
      //   return this.$store.state.$malMainPageConfig.topbox;
      // }
    },
    methods:{

    }
}
</script>

<style scoped lang="scss">
  .centerBox {
    height: 180px;
    width: 1190px;

  }
  .topMenu {
    display: flex;
    height: 60px;
    width: 100%;
    justify-content: flex-start;
    align-items:center;
  }
  .leftitem{
    float:left;
    display: flex;
    justify-content: flex-start;
    width: 40%;

  }
  .rightitem{
    float:right;
    display: flex;
    justify-content: flex-end;
    width: 60%;
    align-items: center;
  }
</style>
